import React from 'react';
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import { Nav } from 'react-bootstrap'
import NavLink from './nav-link'
import useClientLocation from '../../../hooks/use-client-location'
import useUserDiscussions from '../../../hooks/use-user-discussions'
import { AutoEnrollmentButton } from '../../../features/auto-enrollment';

const LeftMenu = () => {
    const { location } = useClientLocation()
    const { hasUnread } = useUserDiscussions()
    return (
        <Nav activeKey={location}>
            <NavLink to={CLIENT_ENDPOINTS.USERS}>USERS</NavLink>
            <NavLink to={CLIENT_ENDPOINTS.EXPERIENCES}>EXPERIENCES</NavLink>
            <NavLink to={CLIENT_ENDPOINTS.LEARNING_RESOURCES}>RESOURCES</NavLink>
            <NavLink to={CLIENT_ENDPOINTS.DISCUSSIONS} badge={hasUnread}>MESSAGES</NavLink>
            <NavLink to={CLIENT_ENDPOINTS.REFLECTION_PROMPTS}>REFLECTIONS</NavLink>
            <NavLink to={CLIENT_ENDPOINTS.REPORTS}>REPORTS</NavLink>
            <NavLink to={CLIENT_ENDPOINTS.SYSTEM}>SYSTEM</NavLink>
            <AutoEnrollmentButton navLinkComponent={NavLink}/>
            <NavLink to={CLIENT_ENDPOINTS.MOBILE}>MOBILE</NavLink>
        </Nav>
    )
}

export default LeftMenu